import React, { ReactNode } from 'react';
import { isArray } from 'lodash';
import { default as $FormItem, FormItemProps } from 'antd/lib/form/FormItem';
import {
	Control,
	ControllerFieldState,
	ControllerRenderProps,
	useController,
} from 'react-hook-form';

// import styles from './FormItem.module.less';

type Props = {
	name: string;
	control: Control<any>;
	hint?: string;
	hideError?: boolean;
	render: ({
		field,
		fieldState,
	}: {
		field: ControllerRenderProps;
		fieldState: ControllerFieldState;
	}) => ReactNode;
} & FormItemProps;

export default function FormItem(props: Props) {
	const { name, control, render, label, className, hint, noStyle, hideError } =
		props;
	const { field, fieldState } = useController({ control, name });
	const { error } = fieldState;
	const currError = isArray(error) ? error.find((e) => e) : error;
	const errorMessage = currError?.message;
	const hasError = !!errorMessage;
	return (
		// eslint-disable-next-line react/jsx-pascal-case
		<$FormItem
			className={className}
			label={label}
			validateStatus={!hasError ? 'success' : 'error'}
			help={
				<span className="hint">
					{!hideError && hasError ? errorMessage : hint}
				</span>
			}
			noStyle={noStyle}
		>
			{render({ field, fieldState })}
		</$FormItem>
	);
}
